
export const all_routes = {
  invoicereport: "/invoice-report",
  pos: "/pos-2",
  customerdisplay: "/customer-display/:locationId",
  customers: "/customers",
  appointments: "/appointments",
  promocodes: "/promo-codes",
  smsdashboard: "/sms/dashboard",
  smstemplates: "/sms/templates",
  smssend: "/sms/send",
  smslogs: "/sms/logs",
  whatsappinbox: "/whatsapp/inbox",
  profile: "/profile",
  signin: "/signin",
  error404: "/error-404",
  error500: "/error-500",
  blankpage: "/blank-page",
  comingsoon: "/coming-soon",
  undermaintenance: "/under-maintenance",
  users: "/users",
  employeegrid: "/employees-grid",
  addemployee: "/add-employee",
  editemployee: "/edit-employee",
  leavesemployee: "/leaves-employee",
  payrollList: "/employee-salary",
  designation: "/designation",
  discountsettings: "/discount-settings",
  printersettings: "/printer-settings",
  usermanual: "/user-manual",

  //New Page
  customer: "/customers",
  posorder: "/pos-orders",
  invoice: "/invoice",
  invoicedetails: "/invoice-details",
  employeedetails: "/employee-details",
  employeelist: "/employees-list",
  expenselist: "/expense-list",
  productlist: "/product-list",
  addproduct: "/add-product",
  categorylist: "/category-list",
  editproduct: "/edit-product",
  productdetails: "/product-details",
  managestock: "/manage-stocks",
  stocktransfer: "/stock-transfer",
  salesdashboard: "/sales-dashboard",
  salesreport: "/sales-report",
  employeeeventreport: "/employee-event-report",
  customerreport: "/customer-report",
  expensereport: "/expense-report",
  bestseller: "/best-seller",
  employeeservicereport: "/employee-service-report",
  giftvouchers: "/gift-vouchers",
};
